import { Component, Input, OnInit } from '@angular/core';
import { MessagingService } from './messaging.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { BrandThemeService } from '../shared/brand-theme.service';
import { environment } from '../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.css']
})
export class MessagingComponent implements OnInit {
  /** Optional: narrow to a thread with this party (username, account name, or url). */
  @Input() otherUserId: string;

  url = '';
  imagesBaseUrl = '';
  messages: any[] = [];
  newMessage = '';
  unreadCount = 0;
  currentUserId: string;
  loadError: string;
  selectedMessage: any = null;

  currentPage = 0;
  pageSize = 10;

  constructor(
    private token: TokenStorageService,
    private messagingService: MessagingService,
    private brandThemeService: BrandThemeService
  ) {}

  ngOnInit(): void {
    const user = this.token.getUser();
    if (!user?.username) {
      this.messages = [];
      this.loadError = 'Sign in to view messages.';
      return;
    }
    this.currentUserId = user.username;

    environment.then((env) => {
      this.url = env['backendURL'];
      this.imagesBaseUrl = env['images'] || '';
      if (!this.url) {
        this.loadError = 'Server address is not configured.';
        return;
      }
      this.loadConversation();
      this.loadUnreadCount();
    });
  }

  get totalPages(): number {
    const n = this.messages?.length ?? 0;
    return Math.max(1, Math.ceil(n / this.pageSize));
  }

  get pagedMessages(): any[] {
    if (!this.messages?.length) {
      return [];
    }
    const start = this.currentPage * this.pageSize;
    return this.messages.slice(start, start + this.pageSize);
  }

  loadConversation(): void {
    this.loadError = undefined;
    const other = (this.otherUserId ?? '').trim();
    this.messagingService
      .getConversation(this.url, this.currentUserId, other)
      .subscribe({
        next: (msgs) => (this.messages = msgs ?? []),
        error: (err) => {
          this.messages = [];
          this.loadError =
            err.error?.error ?? err.error?.message ?? err.message ?? 'Could not load messages.';
        }
      });
  }

  counterpartName(message: any): string {
    if (message?.fromCurrentUser) {
      return message?.counterpartName || message?.receiverName || 'Other';
    }
    return message?.counterpartName || message?.senderName || 'Other';
  }

  getSenderName(message: any): string {
    if (message?.fromCurrentUser) {
      return 'You';
    }
    return this.counterpartName(message);
  }

  getItemName(message: any): string {
    return message?.itemName || 'Item';
  }

  avatarUrl(message: any): string {
    const raw = message?.counterpartAvatarUrl
      || (message?.fromCurrentUser ? message?.receiverAvatarUrl : message?.senderAvatarUrl);
    return this.brandThemeService.resolveMediaUrl(raw, this.imagesBaseUrl);
  }

  selectMessage(message: any): void {
    this.selectedMessage = message;
  }

  clearSelection(): void {
    this.selectedMessage = null;
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
    }
  }

  loadUnreadCount(): void {
    this.messagingService.getUnreadCount(this.url, this.currentUserId).subscribe({
      next: (result) => (this.unreadCount = result?.count ?? 0),
      error: () => (this.unreadCount = 0)
    });
  }
}
